export const FETCH_WEATHER = "FETCH_WEATHER";
export const FETCH_WEATHER_START = "FETCH_WEATHER_START";
export const FETCH_WEATHER_SUCCESS = "FETCH_WEATHER_SUCCESS";
export const FETCH_WEATHER_FAIL = "FETCH_WEATHER_FAIL";



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js